import { createContext } from 'react'

const AssetInventoryContext = createContext()

export default AssetInventoryContext
